import React from "react";
import { Modal } from "antd";

const IndexModal = ({
  open,
  onClose,
  title,
  width = 550,
  children,
  modalContainerClass,
  useCustomClass,
  maxContentHeight = "80vh",
  closable= true,
  description,
}) => {

  const modalClassName = [
    useCustomClass ? "custom-ant-modal-content" : "",
    typeof width === "string" ? width : "",
  ]
  .filter(Boolean)
  .join(" ");

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={width}
      centered
      destroyOnClose
      title={
        (title || description) && (
          <div className="flex flex-col">
            {title && <h2 className="popup-modal-title">{title}</h2>}
            {description && <p className="text-slate-700 text-sm font-normal pl-4">{description}</p>}
          </div>
        )
      }
      className={modalClassName}
      closable={closable}
    >
      <div 
        className={`overflow-y-auto rounded-md ${modalContainerClass}`}
        style={{ maxHeight: maxContentHeight }}
      >
        {children}
                   
      </div>

    </Modal>
  );
};

export default IndexModal;
